/** Level-meter math (pure). Meters show sample peak on a -60…0 dBFS scale. */
export const METER_FLOOR_DB = -60;
/** Fall-off speed of the displayed level, in meter-scale units per second (full scale in ~1.5 s). */
export const METER_RELEASE_PER_SEC = 1 / 1.5;

export function peakOf(samples: Float32Array): number {
  let m = 0;
  for (let i = 0; i < samples.length; i++) {
    const a = Math.abs(samples[i]!);
    if (a > m) m = a;
  }
  return m;
}

/** Linear peak → 0..1 meter position (0 = -60 dBFS or below, 1 = 0 dBFS or above). */
export function peakToMeter(peak: number): number {
  if (!(peak > 0)) return 0;
  const db = 20 * Math.log10(peak);
  return Math.min(1, Math.max(0, (db - METER_FLOOR_DB) / -METER_FLOOR_DB));
}

/** Instant attack, linear release (standard peak-meter ballistics). */
export function meterBallistics(previous: number, next: number, dtSec: number): number {
  return Math.max(next, previous - METER_RELEASE_PER_SEC * Math.max(0, dtSec));
}
